/*
 * <kw-subcollections> – horizontal subcollection row (snippets/kw-subcollections.liquid):
 * prev/next buttons scroll by one "page" of items, buttons are disabled at the ends and the
 * root gets .is-scrollable when the row overflows.
 */
if (!customElements.get("kw-subcollections")) {
  customElements.define(
    "kw-subcollections",
    class KwSubcollections extends HTMLElement {
      connectedCallback() {
        this.root = this.firstElementChild;
        this.track = this.root?.querySelector("[data-kwsub-track]");
        if (!this.track) return;
        this.prev = this.root.querySelector("[data-kwsub-prev]");
        this.next = this.root.querySelector("[data-kwsub-next]");

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.prev?.addEventListener("click", () => this.scrollByPage(-1), { signal });
        this.next?.addEventListener("click", () => this.scrollByPage(1), { signal });
        this.track.addEventListener("scroll", () => requestAnimationFrame(() => this.update()), {
          passive: true,
          signal,
        });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);

        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }

      // One "page" = as many whole items as fit into the visible track
      pageWidth() {
        const item = this.track.querySelector("li");
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const unit = item.offsetWidth + gap;
        return unit * Math.max(1, Math.round(this.track.clientWidth / unit));
      }

      scrollByPage(direction) {
        this.track.scrollBy({ left: direction * this.pageWidth(), behavior: "smooth" });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        this.root.classList.toggle("is-scrollable", scrollWidth - clientWidth > 2);
        if (this.prev) this.prev.disabled = scrollLeft <= 2;
        if (this.next) this.next.disabled = scrollLeft >= scrollWidth - clientWidth - 2;
      }
    }
  );
}
